import { css } from '@linaria/core';
import { useMediaState } from 'modules/Canvas/contexts/MediaProvider/MediaState';
import { useJSONModal } from 'modules/Predictions/components/PredictionSidebar/useUploadModal';
import { Button } from 'components/ui_library/Button';
import { RectRegionThumb } from 'components/Canvas/RegionThumb';
import { IconBoundingBox } from 'components/Icons/IconBoundingBox';
import { CollapsibleBar, CollapsibleBarProps } from '../CollapsibleBar/CollapsibleBar';
import { hasRegions, hasBbox, getFormattedValue } from '../utils';
interface ImageToTextViewProps {
  model: CF.API.Models.Model;
  modelOutput: CF.API.ModelOutputs.ModelOutput;
  regionColorMap: Record<string, string>;
  collapsibleBarProps: Omit<CollapsibleBarProps, 'children' | 'isThresholdSliderVisible'>;
}
export const ImageToTextView = ({
  model,
  modelOutput,
  regionColorMap,
  collapsibleBarProps
}: ImageToTextViewProps): JSX.Element => {
  const {
    data
  } = modelOutput;
  const mediaState = useMediaState();
  const openJsonModal = useJSONModal({
    json: modelOutput
  }, 'model_page');
  return <CollapsibleBar modelId={model.id} isThresholdSliderVisible={false} {...collapsibleBarProps}>
      {hasRegions(data) && data.regions?.map(region => {
      if (!hasBbox(region.region_info)) {
        return null;
      }
      const bbox = region.region_info.bounding_box;
      const text = region.data.text?.raw;
      const score = region.value;
      const conceptColor = regionColorMap[region.id];
      return <div key={region.id} className={imageToText}>
              <div className="icon-wrapper">
                <div>
                  <IconBoundingBox size={18} color="#344054" />
                </div>
                <div className="region-wrapper">
                  <RectRegionThumb id={region.id} regionData={{
              bbox,
              color: '#000'
            }} imageData={mediaState?.imageData} />
                </div>
                {score && <div className="output-text" style={{
            color: conceptColor
          }}>
                    {text}
                  </div>}
              </div>
              {!score && <div className="output-text" style={{
          color: conceptColor
        }}>
                  {text}
                </div>}
              {score && <div className="output-text">{getFormattedValue(score)}</div>}
            </div>;
    })}
      <Button variant="secondary" size="sm" onClick={openJsonModal}>
        View JSON
      </Button>
    </CollapsibleBar>;
};
const imageToText = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageToTextView_tsx-imageToText-i1wvv0r0";

require("./ImageToTextView.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ImageToTextView.tsx");